<template>
  <div class="bg-fa of">
    <section id="index" class="container">
      <header class="comm-title">
        <h2 class="fl tac">
          <span class="c-333">物品列表</span>
        </h2>
      </header>
      <form @submit.prevent="searchThings">
        <div class="mb-3">
          <label for="account" class="form-label">账号</label>
          <input type="text" class="form-control" id="account" v-model="searchParams.account">
        </div>
        <div class="mb-3">
          <label for="isget" class="form-label">是否领取</label>
          <select class="form-select" id="isget" v-model="searchParams.isget">
            <option value="">全部</option>
            <option value="0">未领取</option>
            <option value="1">已领取</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="type" class="form-label">类型</label>
          <select class="form-select" id="type" v-model="searchParams.type">
            <option value="">全部</option>
            <option value="1">普通奖励</option>
            <option value="10">充值领取</option>
            <option value="11">直播奖励363</option>
            <option value="88">直播奖励270</option>
            <option value="12">等级奖励</option>
            <option value="13">新手礼盒</option>
          </select>
        </div>
        <button type="submit" class="btn btn-primary">查询</button>
      </form>
      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="pId" label="物品ID" width="100"></el-table-column>
        <el-table-column prop="pname" label="物品名称"></el-table-column>
        <el-table-column prop="count" label="物品数量"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
        <el-table-column prop="isget" label="是否领取">
          <template slot-scope="scope">
            {{ scope.row.isget === 0 ? '未领取' : '已领取' }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            {{ getTypeLabel(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="play" label="领取角色"></el-table-column>
        <el-table-column prop="ip" label="IP地址"></el-table-column>
        <el-table-column prop="createTime" label="发放时间"></el-table-column>
        <el-table-column prop="updateTime" label="领取时间"></el-table-column>
        <el-table-column prop="trueMoney" label="充值金额"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="updateItem(scope.row.id)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </section>
  </div>
</template>

<script>
import thingApi from '@/api/xuanchuan'; // 导入 xuanchuan.js

export default {
  data() {
    return {
      list: [], // 物品列表
      searchParams: {
        account: '',
        isget: '',
        type: ''
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0 // 总记录数
    };
  },

  created() {
    this.searchThings();
  },

  methods: {
    // 查询物品列表
    searchThings() {
      thingApi.searchXC1(this.currentPage, this.pageSize, this.searchParams)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.total; // 更新总记录数
        })
        .catch((error) => {
          console.error('查询物品失败:', error);
        });
    },

    // 每页显示条数变化时触发
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.searchThings();
    },

    // 当前页码变化时触发
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.searchThings();
    },

    // 获取类型标签
    getTypeLabel(type) {
      switch (type) {
        case 1:
          return '普通奖励';
        case 2:
          return '个人副本奖励';
        case 3:
          return '武道大会半决赛奖励';
        case 4:
          return '武道大会决赛奖励';
        case 5:
          return '竞猜奖励';
        case 6:
          return '竞拍返还(元宝)';
        case 7:
          return '竞拍返还(物品)';
        case 8:
          return '竞拍返还(平分的元宝)';
        case 9:
          return '深渊排名奖励';
        case 10:
          return '充值领取';
        case 11:
          return '直播奖励363';
        case 12:
          return '等级奖励';
        case 13:
          return '新手礼盒';
        case 88:
          return '直播奖励270';
        default:
          return '未知';
      }
    },

    // 修改物品方法
    updateItem(pId) {
      thingApi.updateThing1(pId)
        .then((response) => {
          this.$message.success('修改成功');
          this.searchThings(); // 刷新列表
        })
        .catch((error) => {
          console.error('修改物品失败:', error);
          this.$message.error('修改失败');
        });
    }
  }
};
</script>

<style scoped>
.bg-fa {
  background-color: #f9f9f9;
}

.of {
  overflow: hidden;
}

.form-label {
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}
</style>